import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ShoppingBag } from "lucide-react";
import { NAV, SITE } from "../site";
import GummyBurger from "./GummyBurger";

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const current = pathname.endsWith("/") ? pathname : `${pathname}/`;

  const isActive = (path) =>
    path === "/" ? current === "/" : current.startsWith(path);

  return (
    <header className="sticky top-0 z-50 border-b-2 border-bun/20 bg-white/85 backdrop-blur-md">
      <div className="container-site flex items-center justify-between py-3">
        <Link
          to="/"
          data-testid="navbar-brand-logo"
          className="flex items-center gap-2.5"
          aria-label="Yupi Burger — kembali ke beranda"
        >
          <GummyBurger className="h-9 w-10" title="Logo Yupi Burger" />
          <span className="font-display text-xl font-bold leading-none text-plum">
            Yupi<span className="text-bun-dark">Burger</span>
          </span>
        </Link>

        <nav aria-label="Navigasi utama" className="hidden items-center gap-1 lg:flex">
          {NAV.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              data-testid={item.testid}
              aria-current={isActive(item.path) ? "page" : undefined}
              className={`rounded-full px-4 py-2 font-display text-sm font-semibold transition-colors duration-200 ${
                isActive(item.path)
                  ? "bg-bun text-plum"
                  : "text-plum-soft hover:bg-bun-soft hover:text-plum"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={SITE.official.store}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-cta-yupiland-store"
            className="btn-primary hidden !px-5 !py-2.5 !text-sm sm:inline-flex"
          >
            <ShoppingBag className="h-4 w-4" aria-hidden="true" />
            Beli Sekarang
          </a>
          <button
            type="button"
            data-testid="navbar-mobile-toggle"
            aria-expanded={open}
            aria-controls="mobile-nav"
            aria-label={open ? "Tutup menu navigasi" : "Buka menu navigasi"}
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border-2 border-plum/10 bg-white text-plum transition-colors hover:bg-bun-soft lg:hidden"
          >
            {open ? <X className="h-5 w-5" aria-hidden="true" /> : <Menu className="h-5 w-5" aria-hidden="true" />}
          </button>
        </div>
      </div>

      <div
        id="mobile-nav"
        className={`border-t-2 border-bun/15 bg-white lg:hidden ${open ? "block" : "hidden"}`}
      >
        <nav aria-label="Navigasi seluler" className="container-site flex flex-col gap-1 py-4">
          {NAV.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`mobile-${item.testid}`}
              aria-current={isActive(item.path) ? "page" : undefined}
              onClick={() => setOpen(false)}
              className={`rounded-2xl px-4 py-3 font-display text-base font-semibold ${
                isActive(item.path) ? "bg-bun text-plum" : "text-plum hover:bg-bun-soft"
              }`}
            >
              {item.label}
            </Link>
          ))}
          <a
            href={SITE.official.store}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-navbar-cta-yupiland-store"
            className="btn-primary mt-2"
          >
            <ShoppingBag className="h-4 w-4" aria-hidden="true" />
            Beli di Yupiland Store
          </a>
        </nav>
      </div>
    </header>
  );
}
